(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('SectorTypeDeleteController',SectorTypeDeleteController);

    SectorTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'SectorType'];

    function SectorTypeDeleteController($uibModalInstance, entity, SectorType) {
        var vm = this;
        vm.sectorType = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            SectorType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
